import { render, staticRenderFns } from "./DownloadTableXLSXButton.vue?vue&type=template&id=1cd25540&"
import script from "./DownloadTableXLSXButton.vue?vue&type=script&lang=js&"
export * from "./DownloadTableXLSXButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports